import React from "react";
import pragmaticImg from "./LC-composition_updated-3.png";

export const PragmaticPlayCard = () => {
  const styles = {
    container: {
      marginTop: "0px",
      marginBottom: "24px",
      padding: "20px",
      backgroundColor: "#0d1b2a",
      borderRadius: "12px",
      color: "#fff",
    },
    header: {
      fontSize: "22px",
      fontWeight: "700",
      marginBottom: "20px",
      color: "#f1f5f9",
    },
    card: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#1b263b",
      borderRadius: "12px",
      padding: "16px",
      cursor: "pointer",
      flexWrap: "wrap",
    },
    textBox: {
      flex: "1",
      minWidth: "200px",
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "8px",
      color: "#ffd700",
    },
    description: {
      fontSize: "14px",
      color: "#e0e0e0",
      lineHeight: "1.4",
    },
    image: {
      width: "120px",
      height: "auto",
      borderRadius: "8px",
      marginLeft: "20px",
      flexShrink: 0,
      marginTop: "12px",
    },
  };

  const handleClick = () => {
    window.location.href = "/providers/pragmatic";
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Featured Provider</h2>
      <div style={styles.card} onClick={handleClick}>
        <div style={styles.textBox}>
          <h3 style={styles.title}>Pragmatic Play</h3>
          <p style={styles.description}>
            Explore the best slots, live casino games, and exciting lobbies
            powered by Pragmatic Play!
          </p>
        </div>
        <img src={pragmaticImg} alt="Pragmatic Play" style={styles.image} />
      </div>
    </div>
  );
};
